/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fulfillment_Status_Released_To_3plInputs */

const en_fulfillment_status_released_to_3pl = /** @type {(inputs: Fulfillment_Status_Released_To_3plInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Released to the warehouse`)
};

/**
* | output |
* | --- |
* | "Released to the warehouse" |
*
* @param {Fulfillment_Status_Released_To_3plInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const fulfillment_status_released_to_3pl = /** @type {((inputs?: Fulfillment_Status_Released_To_3plInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fulfillment_Status_Released_To_3plInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fulfillment_status_released_to_3pl(inputs)
});